export default "__VITE_ASSET__BsuW_KP$__"